import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { cookie, Event } from '@ifeng/ui_base';
import errorBoundary from '@ifeng/errorBoundary';
import { handleAd } from '@ifeng/ui_pc_ad';
import { getShortRecommend } from '../../../../services/api';
import ShortVideo from './shortVideo';
import ShortPic from './shortPic';

const formatList = (list, ads) => {
    for (const ad of ads) {
        if (ad.type === 'replaceArr') {
            list.splice(ad.index, 1, { type: 'ad', ref: ad.ref });
        } else if (ad.type === 'insertArr') {
            list.splice(ad.index, 0, { type: 'ad', ref: ad.ref });
        }
    }

    return list;
};

class RelateRecom extends React.PureComponent {
    static propTypes = {
        base62Id: PropTypes.string,
        wxLaunch: PropTypes.object,
        ad: PropTypes.object,
    };

    state = {
        shortData: [],
        ads: [],
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const refs = [];

            replaceArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'replaceArr' });
            });

            insertArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'insertArr' });
            });

            this.setState(
                {
                    ads: [...this.state.ads, ...refs],
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    componentDidMount() {
        this.getShortRecommendData();
    }

    adHandle = async () => {
        const { ad } = this.props;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    };

    getShortRecommendData = async () => {
        const { base62Id } = this.props;
        const config = {
            deviceId: this.createUid(),
            id: `ucms_${base62Id}`,
            from: 'snews_share_relate',
            os: this.getSystem(),
            uid: this.createUid(),
            proid: 'ifengnewsh5',
            gv: '7.1.0',
            publishid: '2006',
        };
        const result = await getShortRecommend(config);

        if (result && result[0] && result[0].item) {
            const data =
                result[0].item &&
                result[0].item.map(item => {
                    let intro = '';

                    if (item.intro && item.intro.length > 31) {
                        intro = `${item.intro.slice(0, 31)}... <span class=${
                            styles.shortAppTxt
                        } style={}>应用内查看全文</span>`;
                    } else if (item.intro && item.intro.length < 31 && item.intro.length > 0) {
                        intro = `${item.intro}<span class=${styles.shortAppTxt}> 应用内查看全文</span>`;
                    } else {
                        intro = '';
                    }

                    return {
                        ...item,
                        intro,
                    };
                });

            this.setState(
                {
                    shortData: data,
                },
                () => {
                    this.adHandle();
                },
            );
        }
    };

    getSystem = () => {
        const UA = navigator.userAgent.toLowerCase();

        if (UA.match(/android/)) {
            return 'android';
        } else {
            return 'iphone';
        }
    };

    createUid = () => {
        if (cookie.get('userid') !== '') return cookie.get('userid');
        const key = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
        let ramStr = parseInt(Math.random() * 268435455).toString(2);
        let mtimeStr = new Date().getTime();

        mtimeStr = mtimeStr.toString(2);
        while (ramStr.length < 28) ramStr = `0${ramStr}`;
        while (mtimeStr.length < 44) mtimeStr = `0${mtimeStr}`;

        const binaryStr = ramStr + mtimeStr;
        let outStr = '';

        for (let i = 0; i < 12; i++) outStr += key.charAt(parseInt(binaryStr.substr(i * 6, 6), 2));

        return outStr;
    };

    render() {
        let { shortData, ads } = this.state;
        const { wxLaunch, ad } = this.props;

        shortData = formatList(shortData, ads);

        return (
            shortData.length > 0 && (
                <section className={styles.relateShortRecom}>
                    {shortData.map((item, index) => {
                        return (
                            <>
                                {item?.style?.view === 'wbcommitvideobigimg' && (
                                    <ShortVideo key={index} wxLaunch={wxLaunch} content={item} />
                                )}
                                {item?.type === 'ad' && (
                                    <div key={index} className={styles.boxBottomLine} ref={item.ref} />
                                )}
                                {item?.style?.view !== 'wbcommitvideobigimg' &&
                                    item?.type !== 'ad' && <ShortPic key={index} wxLaunch={wxLaunch} content={item} />}
                            </>
                        );
                    })}
                </section>
            )
        );
    }
}

export default errorBoundary(RelateRecom);
